import React,{useContext} from 'react'
import Node from './Node'
import NodeContext from '../../contexts/NodeContext'
import icon from '../../assets/nodes/RoundedNode.svg'
import useColors from '../../hooks/useColors'

export default function RoundedNode({id,data,selected,...props}) {
    const [setNodeValue,getNodeValue]=useContext(NodeContext)
    const {getColorToFilter}=useColors()

    return (
        <Node nodeId={id} className='relative text-xs' selected={selected} approved={typeof data?.approved==='boolean'? data?.approved:true}{...props} data={data}><img src={icon} alt='RoundedNode' style={{filter: 'drop-shadow(0px 4px 6px rgba(0,0,0,0.05)) '+getColorToFilter(data?.color)}} /><input className='absolute right-0 text-center -translate-x-1/2 -translate-y-1/2 bg-transparent w-4/5 left-1/2 top-1/2 focus:border-none focus:outline-none' onChange={e => {e.preventDefault(); setNodeValue(id,e.target.value)}} value={data?.text} /></Node>
    )
}
